export default "__VITE_ASSET__19858a5e__"